import { useStorage } from 'mymoria-ui/hooks';
import { useContext } from 'react';
import { FunnelContext } from 'context';

export { default as useWindowSize } from './useWindowSize';
export { default as useStepper } from './useStepper';
export { default as useMobileDetect } from './useMobileDetect';

export const useLocalStorage = useStorage('localStorage');
export const useSessionStorage = useStorage('sessionStorage');
export const useFunnel = () => useContext(FunnelContext);
